var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrPortrait(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-portrait",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.653,
    height: 15.653,
    viewBox: "0 0 15.653 15.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5812",
    "data-name": "Path 5812",
    d: "M12.392,0H3.261A3.265,3.265,0,0,0,0,3.261v9.131a3.265,3.265,0,0,0,3.261,3.261h9.131a3.265,3.265,0,0,0,3.261-3.261V3.261A3.265,3.265,0,0,0,12.392,0ZM4.565,14.348V13.7a3.261,3.261,0,0,1,6.522,0v.652Zm9.783-1.957a1.957,1.957,0,0,1-1.957,1.957V13.7a4.565,4.565,0,0,0-9.131,0v.652A1.957,1.957,0,0,1,1.3,12.392V3.261A1.957,1.957,0,0,1,3.261,1.3h9.131a1.957,1.957,0,0,1,1.957,1.957Z",
    fill: "#bbc6d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5813",
    "data-name": "Path 5813",
    d: "M10.609,4a2.609,2.609,0,1,0,2.609,2.609A2.609,2.609,0,0,0,10.609,4Zm0,3.913a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,10.609,7.913Z",
    transform: "translate(-2.782 -1.391)",
    fill: "#bbc6d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrPortrait);
export default __webpack_public_path__ + "static/media/fi-rr-portrait.c36a33ff.svg";
export { ForwardRef as ReactComponent };